//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as IntereactionActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
import * as Sentry from '@sentry/react';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------
export const handleListChapterInteractions = (chapterID) => async (dispatch) => {
    await dispatch(IntereactionActions.listChapterInteractions());

    try {
        let interactions = [];
        const interactionsRDS = await apis.get('interactionsRDS', `/interactionsByChapter/${chapterID}`);
        if (Array.isArray(interactionsRDS) && interactionsRDS.length > 0) {
            interactions = interactionsRDS
        }
        await dispatch(IntereactionActions.listChapterInteractionsSuccess(interactions));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing chapter interactions',
                error,
                module: 'INTERACTIONS',
                operation: 'LIST_CLASS_INSTRUCTION'
            });
        }
        await dispatch(IntereactionActions.listChapterInteractionsFail(error));
    }
};

//  -- List interactions by type ------

export const handleListInteractions = () => async (dispatch) => {
    await dispatch(IntereactionActions.listInteractions());

    try {
        let interactions = [];
        const interactionsRDS = await apis.get('interactionsRDS', `/list`);
        if (Array.isArray(interactionsRDS) && interactionsRDS.length > 0) {
            interactions = interactionsRDS
        }
        await dispatch(IntereactionActions.listInteractionsSuccess(interactions));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing interactions',
                error,
                module: 'INTERACTIONS',
                operation: 'LIST_INSTRUCTION'
            });
        }
        await dispatch(IntereactionActions.listInteractionsFail(error));
    }
};

export const handleCreateInteractions = (data) => async (dispatch) => {
    await dispatch(IntereactionActions.createInteraction());
    try {
        const interactionsRDS = await apis.post('interactionsRDS', `/interactions`, {
            body: data
        });
        if (has(interactionsRDS, "id")) {
            await dispatch(IntereactionActions.createInteractionSuccess(interactionsRDS));
        }
        return interactionsRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating interactions',
                error,
                module: 'INTERACTIONS',
                operation: 'CREATE_INSTRUCTION'
            });
        }
        await dispatch(IntereactionActions.createInteractionFail(error));
    }
};

export const handleCloudflareVideoStatus = (data) => async (dispatch) => {
    try {
        const interactionsRDS = await apis.post('interactionsRDS', `/cloudflare-video`, {
            body: data
        });
        return interactionsRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'cloudflare video status',
                error,
                module: 'INTERACTIONS',
                operation: 'CLOUDFLARE_VIDEO_STATUS'
            });
        }
    }
};

export const handleUpdateInteractions = (data, withCloudflareCleanup = false) => async (dispatch) => {
    await dispatch(IntereactionActions.updateInteraction());
    try {
        const endpoint = withCloudflareCleanup && data.typeId === 'video' 
            ? `/update-with-cloudflare-cleanup` 
            : `/update`;
        
        const interactionsRDS = await apis.put('interactionsRDS', endpoint, {
            body: data
        });
        if (has(interactionsRDS, "id")) {
            await dispatch(IntereactionActions.updateInteractionSuccess(interactionsRDS));
        }
        return interactionsRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating interactions',
                error,
                module: 'INTERACTIONS',
                operation: 'UPDATE_INSTRUCTION'
            });
        }
        await dispatch(IntereactionActions.updateInteractionFail(error));
    }
};
export const handleTranscriptInteraction = async(id,j_id) => {
    try {
         await apis.post('interactionsRDS', `/scheduleInterationTrancribe`, {
            body: {
                id,
                j_id
            }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'transcribing interaction',
                error,
                module: 'INTERACTIONS',
                operation: 'TEST_INSTRUCTION'
            });
        }
    }
};
export const handleMediaConverterTranscriptInteraction = async(videoUrl,meta_data) => {
    try {
        await apis.post('interactionsRDS', `/media_converter`, {
            body: {
                videoUrl,
                meta_data
            }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'media converter transcript interaction',
                error,
                module: 'INTERACTIONS',
                operation: 'MESSAGE_CLASS_TEACHER_INSTRUCTION'
            });
        }
    }
};
export const handleMediaConverterTranscriptForVStream = async(videoUrl,meta_data) => {
    try {
        await apis.post('interactionsRDS', `/video_transcribe_router`, {
            body: {
                videoUrl,
                meta_data
            }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'media converter transcript interaction',
                error,
                module: 'INTERACTIONS',
                operation: 'MESSAGE_CLASS_TEACHER_INSTRUCTION'
            });
        }
    }
};
export const handleTranscriptEdit = async({url, transcript}) => {
    try {
         return apis.post('interactionsRDS', `/editTranscript`, {
            body: {
                url, transcript
            }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'transcribing edit interaction',
                error,
                module: 'INTERACTIONS',
                operation: 'TEST_EXAM_INSTRUCTION'
            });
        }
    }
};
export const handleJsonToFile = async({url, json}) => {
    try {
         return apis.post('interactionsRDS', `/json_to_file`, {
            body: {
                url, json
            }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'json to file',
                error,
                module: 'INTERACTIONS',
                operation: 'JOIN_TEACHER_FEEDBACK'
            });
        }
    }
};
export const handleDeleteInteractions = (id, withCloudflareCleanup = false) => async (dispatch) => {
    await dispatch(IntereactionActions.deleteInteraction());
    try {
        const endpoint = withCloudflareCleanup 
            ? `/delete-with-cloudflare/${id}` 
            : `/delete/${id}`;
        
        const interactionsRDS = await apis.del('interactionsRDS', endpoint);
        if (has(interactionsRDS, "id")) {
            await dispatch(IntereactionActions.deleteInteractionSuccess(id));
        }
        return interactionsRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting interactions',
                error,
                module: 'INTERACTIONS',
                operation: 'DELETE_INSTRUCTION'
            });
        }
        await dispatch(IntereactionActions.deleteInteractionFail(error));
    }
};

export const handleUpdateSrtIntr = (data) => async (dispatch) => {
    await dispatch(IntereactionActions.updateInteractionSuccess(data));
}


export const handleGenerateTranscript = (data) => async (dispatch) => {
    try {
        const interactionsRDS = await apis.post('interactionsRDS', `/getAudioScript`, {
            body: {
                ...data,
                languageCode: "es-US",
                streaming: true,
                includeTimestamps: true
            }
        });
        return interactionsRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`898 Error generating transcript: ${error}`);
        }
        return null;
    }
};


export const handleTranscriptStatusCheck = async (id) => {
    if (id == null || String(id).trim() === '') {
        return null;
    }
    const path = `/interaction-transcribe-progress/${encodeURIComponent(String(id))}`;
    try {
        return await apis.get('interactionsRDS', path);
    } catch (error) {
        const status =
            error?.response?.statusCode ??
            error?.$metadata?.httpStatusCode ??
            error?.statusCode;
        const msg = String(error?.message || '');
        if (status === 404 || msg.includes('404')) {
            return { success: false, notFound: true };
        }
        if (error && error.message != 'Network Error') {
            logToSentry({
                message: 'interaction transcribe progress check',
                error,
                module: 'INTERACTIONS',
                operation: 'TRANSCRIBE_PROGRESS_CHECK',
            });
        }
        return null;
    }
};

export const handleGetTranscationProgress = (ids) => async (dispatch) => {
    try {
        const interactionsRDS = await apis.post('interactionsRDS', `/interaction-transcribe-progress/batch`, {
            body: {
                ids: ids
            }
        });
        return interactionsRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            Sentry.captureException(`898 Error generating transcript: ${error}`);
        }
        return null;
    }
};